import { IconName, IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const LanguageBadge = (props: { language?: string }) => {
  const lang = (props.language || '').toLowerCase();

  const getIcon = (l: string): IconProp => {
    if (l === 'javascript' || l === 'js') return ['fab','js'];
    if (l === 'typescript' || l === 'ts') return ['fab','js'];
    if (l === 'python' || l === 'py') return ['fab','python'];
    if (l === 'java') return 'coffee';
    if (l === 'c' || l === 'cpp' || l === 'c++') return 'code';
    if (l === 'html') return ['fab','html5'];
    if (l === 'css') return ['fab','css3'];
    if (l === 'php') return ['fab','php'];
    return 'code';
  }

  const icon: IconProp = getIcon(lang);
  const label = (() => {
    if (lang === 'javascript' || lang === 'js') return 'JavaScript';
    if (lang === 'typescript' || lang === 'ts') return 'TypeScript';
    if (lang === 'python' || lang === 'py') return 'Python';
    if (lang === 'java') return 'Java';
    if (lang === 'c') return 'C';
    if (lang === 'cpp' || lang === 'c++') return 'C++';
    if (lang === 'html') return 'HTML';
    if (lang === 'css') return 'CSS';
    if (lang === 'php') return 'PHP';
    // Fallback: return original or Title Case
    const original = props.language || 'Code';
    return original.charAt(0).toUpperCase() + original.slice(1);
  })();

  return (
    <span className="language-badge">
      <FontAwesomeIcon icon={icon} /> {label}
    </span>
  );
}

export default LanguageBadge;


